import { getServiceStatus, OPTIN_STATUS, SCRIPT_NAME } from '@mindscreen/consent/dist/public';

const onSearchEvent = 'mscr:searched';

const onFilterMarkers = (markersById) => (mapId, results) => {
    let minLat = Number.POSITIVE_INFINITY;
    let maxLat = Number.NEGATIVE_INFINITY;
    let minLng = Number.POSITIVE_INFINITY;
    let maxLng = Number.NEGATIVE_INFINITY;
    let minLatAll = Number.POSITIVE_INFINITY;
    let maxLatAll = Number.NEGATIVE_INFINITY;
    let minLngAll = Number.POSITIVE_INFINITY;
    let maxLngAll = Number.NEGATIVE_INFINITY;
    let resultCount = 0;
    results.forEach(([ id, valid ]) => {
        const marker = markersById[id];
        if (marker) {
            marker.setOpacity(valid ? 1 : 0);
            const latLng = marker.getLatLng();
            minLngAll = Math.min(minLngAll, latLng.lng);
            maxLngAll = Math.max(maxLngAll, latLng.lng);
            minLatAll = Math.min(minLatAll, latLng.lat);
            maxLatAll = Math.max(maxLatAll, latLng.lat);
            if (valid) {
                minLng = Math.min(minLng, latLng.lng);
                maxLng = Math.max(maxLng, latLng.lng);
                minLat = Math.min(minLat, latLng.lat);
                maxLat = Math.max(maxLat, latLng.lat);
                marker._icon.classList.add('leaflet-interactive');
            } else {
                marker._icon.classList.remove('leaflet-interactive');
            }
        }
        if (valid) {
            resultCount++;
        }
    });
    if (resultCount > 0) {
        window.openStreetMap.getMap(mapId).fitBounds([
            [ minLat, minLng ],
            [ maxLat, maxLng ],
        ], {
            padding: [ 10, 10 ],
        });
    } else {
        window.openStreetMap.getMap(mapId).fitBounds([
            [ minLatAll, minLngAll ],
            [ maxLatAll, maxLngAll ],
        ], {
            padding: [ 10, 10 ],
        });
    }
};

const initSearch = (mapId) => {
    const form = document.getElementById(mapId + '-filter');
    const title = document.getElementById(mapId + '-title');
    const tableWrapper = document.getElementById(mapId + '-table');
    const table = tableWrapper.querySelector('table');
    const noResults = document.createElement('div');
    noResults.className = 'copy';
    noResults.innerHTML = '<p>Für Ihre Suchanfrage wurden keine Treffer gefunden<p>';
    noResults.style.display = 'none';
    tableWrapper.parentNode.appendChild(noResults);
    const handleSearch = () => {
        const typeFilter = form.querySelector('select').value.trim();
        const textFilter = form.querySelector('input[type="search"]').value.toLowerCase();
        const filterWords = textFilter.split(' ').filter(Boolean);
        let resultCount = 0;
        const results = [];
        for (let i = 1; i < table.rows.length; i++) {
            const row = table.rows[i];
            const id = row.getAttribute('data-id');
            let filterValid = true;
            let typeValid = true;
            if (textFilter) {
                const rowContent = row.innerText.toLowerCase();
                filterValid = filterWords.reduce((c, w) => c && rowContent.includes(w), true);
            }
            if (typeFilter) {
                typeValid = row.cells[2].innerText.trim() === typeFilter;
            }
            const valid = filterValid && typeValid;
            row.style.display = valid ? '' : 'none';
            if (valid) resultCount++;
            results.push([ id, valid ]);
        }
        if (resultCount > 0 || (!textFilter && !typeFilter)) {
            tableWrapper.style.display = '';
            noResults.style.display = 'none';
        } else {
            tableWrapper.style.display = 'none';
            noResults.style.display = 'block';
        }
        let titleText = resultCount + ' Angebote';
        if (textFilter) {
            titleText += ' für "' + textFilter.trim() + '"';
        }
        title.innerText = titleText;
        const event = new CustomEvent(onSearchEvent, { detail: {
            mapId,
            results,
        } });
        window.dispatchEvent(event);
    };
    form.parentElement.style.display = 'block';
    form.addEventListener('submit', e => {
        e.preventDefault();
        handleSearch();
    });
    handleSearch();
    return handleSearch;
};

const getMapIds = () =>
    Array.from(document.querySelectorAll('.tablelist__filter'))
        .map(e => e.id.substr(0, 40));


function init() {
    const handleRowAnchorClick = (mapId, rowId) => (ev) => {
        ev.preventDefault();
        const marker = window.openStreetMap.getMarkers(mapId).find(m => m.feature.options.id === rowId);
        if (!marker)
            return;
        marker.openTooltip();
        const map = window.openStreetMap.getMap(mapId);
        const latLngs = [ marker.getLatLng() ];
        map.fitBounds(latLngs, { maxZoom: 15 });
        document.getElementById(mapId).scrollIntoView();
    };
    const searchHandlers = getMapIds().reduce((dict, mapId) => {
        dict[mapId] = initSearch(mapId);
        return dict;
    }, {});
    document.addEventListener('initializedOpenStreetMap', e => {
        const mapId = e.detail.mapId;
        const markersById = {};
        window.openStreetMap.getMarkers(mapId).forEach(marker => {
            const img = marker._icon;
            const index = marker.feature.options.id;
            markersById[index] = marker;
            marker.bindTooltip([
                `<span class="leaflet-tooltip__title">${marker.feature.properties.tooltip}</span>`,
                `<i>${marker.feature.properties.type}</i>`,
                marker.feature.properties.address,
            ].join('<br/>'));
            img.className += ' tablelist__marker tablelist__marker--' + marker.feature.properties.typeId;
            img.setAttribute('data-index', index);
            img.removeAttribute('tabindex');
            img.addEventListener('click', () => {
                const row = document.querySelector('tr[data-id="' + index + '"]');
                if (row) {
                    row.scrollIntoView();
                    row.querySelector('a,button').focus();
                    row.style.backgroundColor = '#888f';
                    row.className += ' tablelist__row--active';
                    setTimeout(() => {
                        row.style.backgroundColor = '';
                        row.className = row.className.replace('tablelist__row--active', '').trim();
                    }, 500);
                }
            });
        });
        const tableWrapper = document.getElementById(mapId + '-table');
        const table = tableWrapper.querySelector('table');
        for (let i = 1; i < table.rows.length; i++) {
            const row = table.rows[i];
            const rowId = row.getAttribute('data-id');
            const button = document.createElement('button');
            button.className = 'link';
            button.addEventListener('click', handleRowAnchorClick(mapId, rowId));
            button.innerText = 'Auf Karte anzeigen';
            row.children[1].appendChild(document.createElement('br'));
            row.children[1].appendChild(button);
        }
        const filterCallback = onFilterMarkers(markersById);
        window.addEventListener(onSearchEvent, e => {
            filterCallback(e.detail.mapId, e.detail.results);
        });
        if (searchHandlers[mapId]) {
            searchHandlers[mapId]();
        }
    });
}

let initiatedAfterConsent = false;
const initOsm = () => {
    initiatedAfterConsent = true;
    const mapElements = document.querySelectorAll('.tablelist__container .webexcess-openstreetmap>div');
    Array.from(mapElements).forEach(el => {
        el.className += ' webexcess-openstreetmap__map';
        el.parentElement.setAttribute('data-invoked', 'true');
    });
    let skipLinks = document.querySelectorAll('.tablelist__container .skiplink');
    Array.from(skipLinks).forEach(el => {
        el.style.display = '';
    });
};
window[SCRIPT_NAME].on('openstreetmap', status => {
    if (status === OPTIN_STATUS.GRANTED) {
        if (!initiatedAfterConsent) {
            initOsm();
            window.openStreetMap.init();
        }
    }
});
if (getServiceStatus('openstreetmap') === OPTIN_STATUS.GRANTED) {
    initOsm();
}

init();
